import type { FlexProps } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslations } from '@ui/i18n';
import React from 'react';

import Info from './Info';

export type ApyInfoProps = {
  netApy: string;
  grossApy: string;
} & FlexProps;

function ApyInfo({ netApy, grossApy, ...flexProps }: ApyInfoProps) {
  const t = useTranslations();
  return (
    <Flex
      gap={4}
      flexDir="column"
      px={{ base: 0, desktop: 8 }}
      py={{ base: 0, desktop: 4 }}
      minW={{ base: 'full', desktop: '407px' }}
      {...flexProps}
    >
      <Info title={t('Net APY')} value={netApy} />
      <Info title={t('Gross APY')} value={grossApy} />
      <Info
        title={t('Management Fees')}
        value="10%"
        convertedValue={
          <Flex flexDir="column">
            <Text>Treasury 50%</Text>
            <Text>Reservoir 50%</Text>
          </Flex>
        }
      />
    </Flex>
  );
}

export default ApyInfo;
